import { createAction, props } from '@ngrx/store';
import { Order } from '@shared/models/order';

export const unsuspendOrder = createAction('[Orders] Unsuspend Order', props<{ orderId: number; reason: string }>());

export const unsuspendOrderSuccess = createAction('[Orders] Unsuspend Order Success', props<{ order: Order }>());

export const unsuspendOrderFailure = createAction('[Orders] Unsuspend Order Failure', props<{ error: any }>());
